import { render, staticRenderFns } from "./Adresseline.vue?vue&type=template&id=5f60ff70&"
import script from "./Adresseline.vue?vue&type=script&lang=js&"
export * from "./Adresseline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports